(function () {
  const TZ = 'Europe/Madrid';
  const DAY_START_HOUR = 10;
  const DAY_END_HOUR = 22;

  function madridParts(date) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);

    const get = function (type) {
      const part = parts.find(function (p) {
        return p.type === type;
      });
      return part ? part.value : '0';
    };

    return {
      year: Number(get('year')),
      month: Number(get('month')),
      day: Number(get('day')),
      hour: Number(get('hour')),
      minute: Number(get('minute')),
      second: Number(get('second')),
    };
  }

  /* Convert a Europe/Madrid wall-clock datetime to a UTC Date. */
  function madridWallTimeToUtc(year, month, day, hour, minute, second) {
    let guess = Date.UTC(year, month - 1, day, hour, minute, second || 0);

    for (let i = 0; i < 3; i++) {
      const shown = madridParts(new Date(guess));
      const asUtc = Date.UTC(
        shown.year,
        shown.month - 1,
        shown.day,
        shown.hour,
        shown.minute,
        shown.second
      );
      const desired = Date.UTC(year, month - 1, day, hour, minute, second || 0);
      guess += desired - asUtc;
    }

    return new Date(guess);
  }

  function nextMadridDay(year, month, day) {
    const next = new Date(Date.UTC(year, month - 1, day + 1));
    return {
      year: next.getUTCFullYear(),
      month: next.getUTCMonth() + 1,
      day: next.getUTCDate(),
    };
  }

  /*
   * Two 12-hour windows in Europe/Madrid:
   *   10:00 → 22:00  daytime offer
   *   22:00 → 10:00  extended offer
   */
  function getWindow(now) {
    const p = madridParts(now);
    let extended;
    let endYear;
    let endMonth;
    let endDay;
    let endHour;

    if (p.hour >= DAY_START_HOUR && p.hour < DAY_END_HOUR) {
      extended = false;
      endYear = p.year;
      endMonth = p.month;
      endDay = p.day;
      endHour = DAY_END_HOUR;
    } else if (p.hour >= DAY_END_HOUR) {
      extended = true;
      const tomorrow = nextMadridDay(p.year, p.month, p.day);
      endYear = tomorrow.year;
      endMonth = tomorrow.month;
      endDay = tomorrow.day;
      endHour = DAY_START_HOUR;
    } else {
      extended = true;
      endYear = p.year;
      endMonth = p.month;
      endDay = p.day;
      endHour = DAY_START_HOUR;
    }

    return {
      extended: extended,
      deadline: madridWallTimeToUtc(endYear, endMonth, endDay, endHour, 0, 0),
    };
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemaining(ms) {
    if (ms < 0) ms = 0;
    const total = Math.floor(ms / 1000);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function initRoot(root) {
    if (root.dataset.lmCountdownReady === 'true') return;
    root.dataset.lmCountdownReady = 'true';

    const labelEl = root.querySelector('[data-lm-countdown-label]');
    const timerEl = root.querySelector('[data-lm-countdown-timer]');
    const dayText = root.getAttribute('data-countdown-text') || '';
    const extendedText = root.getAttribute('data-countdown-extended-text') || '';

    function tick() {
      const windowState = getWindow(new Date());
      const label = windowState.extended ? extendedText : dayText;

      if (labelEl && labelEl.textContent !== label) {
        labelEl.textContent = label;
      }

      if (timerEl) {
        timerEl.textContent = formatRemaining(windowState.deadline.getTime() - Date.now());
      }

      root.dataset.countdownMode = windowState.extended ? 'extended' : 'day';
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-lm-countdown]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
